import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import CatalogCard from "@/Components/Site/CatalogCard";
import {isDesktop, isMobile} from "@/Helpers/Function";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/platina-art.scss';

class PlatinaArt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSvg: false,
            videoPlayPauseFlag: true,
            videoNorthernLightsVolumeSvg: true,
            // Сколько показывать карточек при загрузке
            cardListCountOne: isMobile() ? 2 : 5,
            cardListCountTwo: isMobile() ? 2 : 5,
            cardListCountThree: isMobile() ? 2 : 5,
            cardListCountFour: isMobile() ? 2 : 5,
            cardListCountFive: isMobile() ? 2 : 5,
            cardListCountSix: isMobile() ? 2 : 5,
            cardListCountSeven: isMobile() ? 2 : 5,
            cardListCountEight: isMobile() ? 2 : 5,
            cardListCountNine: isMobile() ? 2 : 5,
            // Сколько прибавлять карточек (показать еще)
            cardListCountAdd: isMobile() ? 4 : 10,
            // Количество активных карточек при старте
            cardOneActive: [],
            cardTwoActive: [],
            cardThreeActive: [],
            cardFourActive: [],
            cardFiveActive: [],
            cardSixActive: [],
            cardSevenActive: [],
            cardEightActive: [],
            cardNineActive: [],
        };
        this.videoRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            video.onended = (e) => {
                video.muted = true;
                this.setState({
                    videoSvg: true,
                    videoNorthernLightsVolumeSvg: true
                })
            };
        }
    }

    videoTimer = () => setTimeout(() => {
        this.setState({videoPlayPauseFlag: false})
    }, 3000);

    /**
     * Управление звуком
     */
    mediaChangeVolume = () => {
        try {
            const video = this.videoRef.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoNorthernLightsVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({videoNorthernLightsVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerId);
                if (!this.state.videoPlayPauseFlag) {
                    this.setState({videoPlayPauseFlag: true})
                }
                this.videoTimerId = this.videoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChange = () => {
        try {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    // Добавляем карточки при клике на (показать еще)
    showMore = (set, setAdd) => {
        this.setState({
            [set]: this.state[set] + this.state[setAdd],
        });
    }

    // Показать еще текст кнопки
    showMoreMessage = (count, setAdd) => {
        if (this.state[setAdd] < count) {
            return `Показать еще ${this.state[setAdd]} из ${count}`;
        } else {
            return `Показать еще ${count}`;
        }
    };

    render() {
        const {collectionDetailedData = {}, uploadUrl = '', registerView} = this.props;

        const {
            videoSvg,
            videoPlayPauseFlag,
            videoNorthernLightsVolumeSvg
        } = this.state;

        // Собираем карточки
        let dataOne = [], dataTwo = [], dataThree = [], dataFour = [], dataFive = [], dataSix = [], dataSeven = [],
            dataEight = [], dataNine = [];
        let countOne = 0, countTwo = 0, countThree = 0, countFour = 0, countFive = 0, countSix = 0, countSeven = 0,
            countEight = 0, countNine = 0, offset = 0;
        if (Object.keys(collectionDetailedData).length > 0) {
            this.state.cardOneActive = collectionDetailedData.setOne.slice(0, this.state.cardListCountOne);
            countOne = collectionDetailedData.setOne.length - this.state.cardOneActive.length;
            dataOne = this.state.cardOneActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setOne.length;
            this.state.cardTwoActive = collectionDetailedData.setTwo.slice(0, this.state.cardListCountTwo);
            countTwo = collectionDetailedData.setTwo.length - this.state.cardTwoActive.length;
            dataTwo = this.state.cardTwoActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setTwo.length;
            this.state.cardThreeActive = collectionDetailedData.setThree.slice(0, this.state.cardListCountThree);
            countThree = collectionDetailedData.setThree.length - this.state.cardThreeActive.length;
            dataThree = this.state.cardThreeActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setThree.length;
            this.state.cardFourActive = collectionDetailedData.setFour.slice(0, this.state.cardListCountFour);
            countFour = collectionDetailedData.setFour.length - this.state.cardFourActive.length;
            dataFour = this.state.cardFourActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setFour.length;
            this.state.cardFiveActive = collectionDetailedData.setFive.slice(0, this.state.cardListCountFive);
            countFive = collectionDetailedData.setFive.length - this.state.cardFiveActive.length;
            dataFive = this.state.cardFiveActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setFive.length;
            this.state.cardSixActive = collectionDetailedData.setSix.slice(0, this.state.cardListCountSix);
            countSix = collectionDetailedData.setSix.length - this.state.cardSixActive.length;
            dataSix = this.state.cardSixActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setSix.length;
            this.state.cardSevenActive = collectionDetailedData.setSeven.slice(0, this.state.cardListCountSeven);
            countSeven = collectionDetailedData.setSeven.length - this.state.cardSevenActive.length;
            dataSeven = this.state.cardSevenActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setSeven.length;
            this.state.cardEightActive = collectionDetailedData.setEight.slice(0, this.state.cardListCountEight);
            countEight = collectionDetailedData.setEight.length - this.state.cardEightActive.length;
            dataEight = this.state.cardEightActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setEight.length;
            this.state.cardNineActive = collectionDetailedData.setNine.slice(0, this.state.cardListCountNine);
            countNine = collectionDetailedData.setNine.length - this.state.cardNineActive.length;
            dataNine = this.state.cardNineActive.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.setNine.length;
        }

        return <section className={`section section__platinaArt`}>
            <div className={`collections-lp`}>
                <div className={`container`}>
                    <div className={`platinaArtLogo`}>
                        <picture>
                            <source type="image/webp"
                                    srcSet={`/storage/img/collections/platina-art/platina_art_logo.webp`}
                            />
                            <img src={`/storage/img/collections/platina-art/platina_art_logo.png`}
                                 alt={`Logo`}
                                 loading="lazy"
                                 width={`400`}
                                 height={`80`}
                            />
                        </picture>
                        <p className={`platinaArtLogo__text`}>
                            ювелирное искусство
                        </p>
                    </div>
                    <div className={`platinaArt-wrapper`}>
                        <div className={`platinaArt-wrapper__video-main`}>
                            <video ref={this.videoRef}
                                   autoPlay
                                   muted={`muted`}
                                   preload={`none`}
                                   width={`100%`}
                                   poster={isMobile() ? `/storage/img/collections/platina-art/video-poster-mobile.jpg` : '/storage/img/collections/platina-art/video-poster.jpg'}
                            >
                                <source
                                    src={isMobile() ? `${uploadUrl}/media/video/collections/platina-art/art-767x767.mp4` : `${uploadUrl}/media/video/collections/platina-art/art-1330x624.mp4`}
                                    type={`video/mp4`} />
                                <source
                                    src={isMobile() ? `${uploadUrl}/media/video/collections/platina-art/art-767x767.webm` : `${uploadUrl}/media/video/collections/platina-art/art-1330x624.webm`}
                                    type={`video/webm`} />
                                <source
                                    src={isMobile() ? `${uploadUrl}/media/video/collections/platina-art/art-767x767.ogg` : `${uploadUrl}/media/video/collections/platina-art/art-1330x624.ogg`}
                                    type={`video/ogg`} />
                            </video>
                            <div className={`video-control`} onClick={() => this.mediaChangePlayPause()}>
                                {videoSvg ?
                                    <div className={`gg-play-button`} onClick={() => this.mediaChange()}></div>
                                    :
                                    <>
                                        {videoPlayPauseFlag && (
                                            <div className={`gg-pause-button`} onClick={() => this.mediaChange()}></div>
                                        )}
                                    </>
                                }
                                <div className={`volume`} onClick={() => this.mediaChangeVolume()}>
                                    {videoNorthernLightsVolumeSvg ?
                                        <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                                        :
                                        <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                                    }
                                </div>
                            </div>
                        </div>
                        <h1 className={`h1 h1__platinaArt`}>
                            Коллекция PLATINA ART&nbsp;&mdash; это ювелирное искусство, вдохновленное полётом
                            воображения и&nbsp;рациональностью, мечтательностью и&nbsp;творческим расчетом,
                            свободой и&nbsp;неординарностью сюрреализма.
                        </h1>
                        <p className={`platinaArt-wrapper__description platinaArt-wrapper__description_one`}>
                            Мы&nbsp;рады представить вам девять захватывающих сетов. Каждый
                            из&nbsp;них&nbsp;&mdash; это единение экспрессии и&nbsp;ювелирной эстетики,
                            фантастики
                            и&nbsp;реальности, стиля и&nbsp;изящества.
                            У&nbsp;каждого из&nbsp;них&nbsp;&mdash; своя смысловая наполненность, воплощённая
                            в&nbsp;символичных и&nbsp;волнующих образах. Каждый из&nbsp;них имеет свою
                            ирреальную
                            и&nbsp;манящую атмосферу.
                        </p>
                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_one`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-one-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-one-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-one-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-one-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_odd platinaArt-wrapper__set-content_one`}>
                                <p className={`set set__one`}>Сет</p>
                                <p className={`title title__one`}>Мудрость жизни</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        &laquo;Мудрость жизни&raquo;&nbsp;&mdash; это нетривиальные штрихи
                                        вашего
                                        образа. Ваша пленительность. Ваш шарм. Это украшения, которые
                                        не&nbsp;оставят никого равнодушным.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    &laquo;Мудрость жизни&raquo;&nbsp;&mdash; это нетривиальные штрихи вашего
                                    образа. Ваша пленительность. Ваш шарм. Это украшения, которые
                                    не&nbsp;оставят никого равнодушным.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataOne}
                            </div>
                        </div>
                        {countOne !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountOne', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countOne, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}

                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_two`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-two-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-two-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-two-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-two-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_even platinaArt-wrapper__set-content_two`}>
                                <p className={`set set__two`}>Сет</p>
                                <p className={`title title__two`}>Мелодия ночи</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения, которые наполнят ваш образ пленительностью, мечтательностью,
                                        эмоциональностью. Украшения, которые чаруют.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения, которые наполнят ваш образ пленительностью, мечтательностью,
                                    эмоциональностью. Украшения, которые чаруют.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataTwo}
                            </div>
                        </div>
                        {countTwo !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountTwo', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countTwo, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}
                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_three`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-three-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-three-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-three-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-three-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_odd platinaArt-wrapper__set-content_three`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>Взгляд на время</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Роскошная загадка вашего образа. Ваша личная захватывающая тайна. Это
                                        украшения, которые будоражат воображение окружающих.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Роскошная загадка вашего образа. Ваша личная захватывающая тайна. Это
                                    украшения, которые будоражат воображение окружающих.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataThree}
                            </div>
                        </div>
                        {countThree !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountThree', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countThree, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}

                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_four`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-four-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-four-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-four-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-four-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_even platinaArt-wrapper__set-content_four`}>
                                <p className={`set set__two`}>Сет</p>
                                <p className={`title title__two`}>Тайна красоты</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения, делающие свою обладательницу центром всеобщего внимания.
                                        Украшения, которые придают образу лёгкость, обворожительность
                                        и&nbsp;магнетический шарм.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения, делающие свою обладательницу центром всеобщего внимания.
                                    Украшения, которые придают образу лёгкость, обворожительность
                                    и&nbsp;магнетический шарм.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataFour}
                            </div>
                        </div>
                        {countFour !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountFour', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countFour, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}
                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_five`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-five-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-five-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-five-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-five-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_odd platinaArt-wrapper__set-content_five`}>
                                <p className={`set set__five`}>Сет</p>
                                <p className={`title title__five`}>Преображение</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения, которые впечатляют своей сложностью исполнения
                                        и&nbsp;лёгкостью восприятия одновременно. Они преображают ваш образ,
                                        наполняя его ореолом нежности, женственности, пленительности.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения, которые впечатляют своей сложностью исполнения и&nbsp;лёгкостью
                                    восприятия одновременно. Они преображают ваш образ, наполняя его ореолом
                                    нежности, женственности, пленительности.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataFive}
                            </div>
                        </div>
                        {countFive !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountFive', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countFive, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}

                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_six`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-six-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-six-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-six-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-six-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_even platinaArt-wrapper__set-content_six`}>
                                <p className={`set set__six`}>Сет</p>
                                <p className={`title title__six`}>Обольщение</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Смелые и&nbsp;яркие украшения, достойные стать броскими
                                        и&nbsp;соблазнительными штрихами образа.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Смелые и&nbsp;яркие украшения, достойные стать броскими
                                    и&nbsp;соблазнительными штрихами образа.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataSix}
                            </div>
                        </div>
                        {countSix !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountSix', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countSix, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}
                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_seven`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-seven-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-seven-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-seven-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-seven-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_odd platinaArt-wrapper__set-content_seven`}>
                                <p className={`set set__seven`}>Сет</p>
                                <p className={`title title__seven`}>Загадочность</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения с&nbsp;невероятно-притягательным характером. Это чарующие
                                        штрихи вашего образа, с&nbsp;которыми легко создать ореол загадки,
                                        тайны, многозначительности.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения с&nbsp;невероятно-притягательным характером. Это чарующие штрихи
                                    вашего образа, с&nbsp;которыми легко создать ореол загадки, тайны,
                                    многозначительности.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataSeven}
                            </div>
                        </div>
                        {countSeven !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountSeven', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countSeven, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}

                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_eight`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-eight-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-eight-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-eight-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-eight-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_even platinaArt-wrapper__set-content_eight`}>
                                <p className={`set set__eight`}>Сет</p>
                                <p className={`title title__eight`}>Ночная магия</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения для тех, кто любит и&nbsp;ценит стильные дизайнерские
                                        воплощения. Это эффектные штрихи образа для тех, кто обладает природным
                                        шармом и&nbsp;смелостью. Для тех, кого влечёт всё неизведанное,
                                        удивительное и&nbsp;непостижимое.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения для тех, кто любит и&nbsp;ценит стильные дизайнерские воплощения.
                                    Это эффектные штрихи образа для тех, кто обладает природным шармом
                                    и&nbsp;смелостью. Для тех, кого влечёт всё неизведанное, удивительное
                                    и&nbsp;непостижимое.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataEight}
                            </div>
                        </div>
                        {countEight !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountEight', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countEight, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}

                        <div className={`platinaArt-wrapper__set platinaArt-wrapper__set_nine`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-nine-img-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/platina-art/set-nine-img.webp`}
                                />
                                <source srcSet={`/storage/img/collections/platina-art/set-nine-img-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/platina-art/set-nine-img.jpg`}
                                     alt={`Сет`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "1380" : "624"}
                                />
                            </picture>
                            <div
                                className={`platinaArt-wrapper__set-content platinaArt-wrapper__set-content_odd platinaArt-wrapper__set-content_nine`}>
                                <p className={`set set__nine`}>Сет</p>
                                <p className={`title title__nine`}>Постижение тайн</p>
                                {!isMobile() && (
                                    <p className={`text`}>
                                        Украшения, которые привлекают внимание. Это ваши волнующие акценты
                                        образа. Стильные штрихи, подчёркивающие вашу врождённую грацию,
                                        неповторимость, изящество.
                                    </p>
                                )}
                            </div>
                            {isMobile() && (
                                <p className={`text-mobile`}>
                                    Украшения, которые привлекают внимание. Это ваши волнующие акценты образа.
                                    Стильные штрихи, подчёркивающие вашу врождённую грацию, неповторимость,
                                    изящество.
                                </p>
                            )}
                        </div>
                        <div className={`cardAll cardAll__platinaArt`}>
                            <div className={`cardAll__catalog`}>
                                {dataNine}
                            </div>
                        </div>
                        {countNine !== 0 && (
                            <div className={`buttons buttons__showMore`}>
                                <div className={`btn btn__showMore`}
                                     onClick={() => this.showMore('cardListCountNine', 'cardListCountAdd')}>
                                    {this.showMoreMessage(countNine, 'cardListCountAdd')}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    }
}

export default withViewItemBatcher(useWithStore(PlatinaArt));
